export default function ResultsTable(props) {
	
	console.log(props.resultsData)

	{/*let objPortfolioData = {
		benchmarkData: '—',
		effectiveDuration: '—',
		prospectusNetExpenseRatio: '—',
		threeYearAnnualized: '—',
		threeYearRiskAnnualized: '—',
		twelveMonthTrailingYield: '—',
		taxes: '—',
	}*/}

	let objPortfolioData = {
		twelveMonthTrailingYield: '—',
		oneYearReturn: '—',
		oneYearStdDev: '—',
		correlationSP500: '—',
		duration: '—',
		expenseRatio: '—'
	};


	if (
		props.resultsData &&
		props.resultsData.portfolioResponse &&
		props.resultsData.portfolioResponse.portfolio
	) {
		const portfolio = props.resultsData.portfolioResponse.portfolio;

		// ccw 2026-09-27 [bp-metrics]: look metrics up by name, not array position. Positions [24] and [16] had
		// shifted to annualizedReturnTotal and sharpeRatioTotal, so "Standard deviation" and "Correlation" showed the wrong figures.
		const getMetric = (name) => portfolio.performance?.expostMetrics?.metrics?.find(m => m.name === name)?.value ?? null;
		const oneYearReturn = getMetric('annualizedReturn1Yr');
		const oneYearStdDev = getMetric('annualizedVolatility1Yr');
		const correlationSP500 = getMetric('correlationSP1Yr');
		const trailingYield = portfolio.characteristics?.find(c => c.name === 'twelveMonthTrailingYield')?.total ?? null;

		try {
			objPortfolioData = {
				// ccw 2026-09-27 [bp-metrics]: was `?.toFixed(2) + '%' || '—'`, which rendered "undefined%" when missing
				twelveMonthTrailingYield: trailingYield != null ? trailingYield.toFixed(2) + '%' : '—',
				duration: portfolio.characteristics.find(c => c.name === 'duration')?.total?.toFixed(2) || '—',
				expenseRatio: (() => {
					const net = portfolio.characteristics.find(c => c.name === 'expenseRatio')?.total ?? null;
					const gross = portfolio.characteristics.find(c => c.name === 'grossExpenseRatio')?.total ?? null;
					if (net != null && gross != null) return `${net.toFixed(2)}% / ${gross.toFixed(2)}%`;
					if (net != null) return `${net.toFixed(2)}%`;
					if (gross != null) return `${gross.toFixed(2)}%`;
					return '—';
				})(),
				oneYearReturn: oneYearReturn != null ? (oneYearReturn * 100).toFixed(2) + '%' : '—',
				oneYearStdDev: oneYearStdDev != null ? (oneYearStdDev * 100).toFixed(2) + '%' : '—',
				correlationSP500: correlationSP500 != null ? correlationSP500.toFixed(2) : '—'
			};
		} catch (err) {
			console.warn('Failed to parse metrics:', err);
		}
	}

	{/*if (props.resultsData && props.resultsData.portfolioResponse && props.resultsData.portfolioResponse.portfolio) {
		
		let myresultsData = props.resultsData.portfolioResponse
		
		console.log(myresultsData.portfolio)
		console.log(myresultsData.portfolio.characteristics[0].total)

		let bmData = '-'

	
	
		// Make sure the data coming in fits what we need, or else we just stick to the defaults.
		if (myresultsData.portfolio && 
			myresultsData.portfolio.characteristics[0].total) {
	
			let prospectusNetExpenseRatio = myresultsData.portfolio.characteristics[3].total;
			let effectiveDuration =  myresultsData.portfolio.characteristics[0].total
			let twelveMonthTrailingYield =  myresultsData.portfolio.characteristics[2].total
			let threeYearAnnualized = myresultsData.portfolio.performance.expostMetrics.metrics[20].value;
			let threeYearRiskAnnualized =  myresultsData.portfolio.performance.expostMetrics.metrics[25].value;
			let benchmarkData =  myresultsData.portfolio.performance.expostMetrics.metrics[17].value;
		
	
			objPortfolioData = {
				...objPortfolioData,
				effectiveDuration: (effectiveDuration?(effectiveDuration).toFixed(2):'—') + '',
				twelveMonthTrailingYield: (twelveMonthTrailingYield?(twelveMonthTrailingYield).toFixed(2):'—') + '%',
				prospectusNetExpenseRatio: (prospectusNetExpenseRatio?(prospectusNetExpenseRatio).toFixed(2):'—') + '%',
				threeYearRiskAnnualized: (threeYearRiskAnnualized?(threeYearRiskAnnualized*100).toFixed(2):'—') + '%',
				benchmarkData: (benchmarkData?(benchmarkData).toFixed(2):'—') + ''
			}
	
		
		}


		

	} else {
		console.log('Portfolio data is undefined');
	}


	*/}

	
	
	return (
		<div className="results-table" >
			<table width="98%">
				<tbody>
					<tr>
						<th>Trailing 12-mo yield</th>
						<td>{objPortfolioData.twelveMonthTrailingYield}</td>
					</tr>
					<tr>
						<th>Total return (1-year)</th>
						<td>{objPortfolioData.oneYearReturn}</td>
					</tr>
					<tr>
						<th>Standard deviation (1-year)</th>
						<td>{objPortfolioData.oneYearStdDev}</td>
					</tr>
					<tr>
						<th>Correlation to S&amp;P 500</th>
						<td>{objPortfolioData.correlationSP500}</td>
					</tr>
					<tr>
						<th>Duration</th>
						<td>{objPortfolioData.duration}{objPortfolioData.duration !== '—' ? ' years' : ''}</td>
					</tr>
					<tr>
						<th>Net/gross expense ratio</th>
						<td>{objPortfolioData.expenseRatio}</td>
					</tr>
				</tbody>
			</table>
		</div>
	)
}